// Eski OrderMenuX QR kodlarına gelen müşterileri yeni RestoMenuX menü sayfasına yönlendirir.
// Anahtarlar KÜÇÜK HARF olmalı; karşılaştırma büyük/küçük harften bağımsız yapılır.
const RESTOMENUX_MENU_BASE_URL = 'https://restomenux.com/menu';

const MENU_REDIRECTS = {
  // OrderMenuX QR ID -> RestoMenuX menü ID
  '0b9f990b-e74e-4cbb-85c3-e37c28e0fd9d': '45CFF98E-A186-4A0A-92E7-15510886730D',
  '77678f12-ff83-4dfc-82e3-1c2a2dfa604f': '45CFF98E-A186-4A0A-92E7-15510886730D',
};

/**
 * Verilen QR ID için yönlendirilecek RestoMenuX adresini döner, yoksa null.
 * @param {string} qrMenuId URL'deki QR kod ID'si
 * @param {string} [lang] Korunacak dil parametresi (tr/en)
 */
export const getMenuRedirectUrl = (qrMenuId, lang) => {
  if (!qrMenuId) return null;

  const targetId = MENU_REDIRECTS[String(qrMenuId).trim().toLowerCase()];
  if (!targetId) return null;

  const url = `${RESTOMENUX_MENU_BASE_URL}/${targetId}`;
  return lang ? `${url}?lang=${encodeURIComponent(lang)}` : url;
};

/**
 * Yönlendirme tanımlıysa tarayıcıyı RestoMenuX'e taşır ve true döner.
 * Geri tuşunda eski menüye dönülüp döngüye girilmemesi için replace kullanılır.
 */
export const redirectToRestoMenuXIfNeeded = (qrMenuId, lang) => {
  const url = getMenuRedirectUrl(qrMenuId, lang);
  if (!url) return false;

  window.location.replace(url);
  return true;
};
